import {
    GoogleReCaptchaProvider,
    useGoogleReCaptcha
} from 'react-google-recaptcha-v3';
import axios from 'axios';
import React, {useEffect, useState, useCallback} from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { verifyRecaptchaGeneralRequest, verifyRecaptchaImageAuthRequest, verifyRecaptchaImageRequest, verifyRecaptchaPhoneRequest, verifyRecaptchaRequest } from '../../redux/actions/Auth';
import ReCAPTCHA from 'react-google-recaptcha';
import { injectIntl } from 'react-intl';

const Recaptcha = ({onValidToken, type = null,intl}) => {
    const { executeRecaptcha } = useGoogleReCaptcha();
    const {token,recaptchaDataPhone,recaptchaDataGeneral, loading,imageVerified} = useSelector(({auth}) => auth)    
    const dispatch = useDispatch();
    const {locale} = useSelector(({common}) => common)

    const [showImageRecaptcha, setShowImageRecaptcha] = useState(false);
    const [afterVerifyImage,setAfterVerifyImage] = useState(false)
    const [recaptchaV2Token, setRecaptchaV2Token] = useState(null);

    const [recaptchaReady, setRecaptchaReady] = useState(false);

    useEffect(() => {
      const interval = setInterval(() => {
        if (window.grecaptcha && window.grecaptcha.render) {
          setRecaptchaReady(true);
          clearInterval(interval);
        }
      }, 100);
      return () => clearInterval(interval);
    }, []);

    
    // Create an event handler so you can call the verification on button click event or form submit
    const handleReCaptchaVerify = useCallback(async () => {
      if (!executeRecaptcha) {
        console.log('Execute recaptcha not yet available');
        return;
      }
      const tokenRecaptcha = await executeRecaptcha('register');     
      
      if (tokenRecaptcha) {
        if (type == 'phone') {
            dispatch(verifyRecaptchaPhoneRequest(tokenRecaptcha, token)); 
        } else {
            dispatch(verifyRecaptchaGeneralRequest(tokenRecaptcha));
        }
    }
  }, [executeRecaptcha, type, dispatch, token, imageVerified]);

  useEffect(() => {
    if (type === 'phone' && recaptchaDataPhone) {
        if (recaptchaDataPhone?.score < 0.3 && !afterVerifyImage) {
          setShowImageRecaptcha(true);
        } else {          
          onValidToken(recaptchaDataPhone, recaptchaDataPhone?.tokenRecaptcha,'v3');
        }
    } else if (type !== 'phone' && recaptchaDataGeneral) {
        if (recaptchaDataGeneral?.score < 0.3 && !afterVerifyImage) {
          setShowImageRecaptcha(true);
        } else {
          onValidToken(recaptchaDataGeneral, recaptchaDataGeneral?.tokenRecaptcha,'v3');
        }
    }
  }, [loading, recaptchaDataPhone?.tokenRecaptcha, recaptchaDataGeneral?.tokenRecaptcha, onValidToken, type, recaptchaDataPhone, recaptchaDataGeneral]);

  
    //You can use useEffect to trigger the verification as soon as the component being loaded
    useEffect(() => {
      handleReCaptchaVerify();
    }, [handleReCaptchaVerify]);


    const handleImageRecaptcha = (tokenRecaptchaV2) => {
      if (tokenRecaptchaV2) {
        dispatch(verifyRecaptchaImageRequest(tokenRecaptchaV2));
          setRecaptchaV2Token(tokenRecaptchaV2);
      }
    };

    useEffect(() => {
      if (imageVerified && recaptchaV2Token) {
        onValidToken(imageVerified, recaptchaV2Token,'v2');
        setAfterVerifyImage(true);
        setShowImageRecaptcha(false);
      }
    
      if (!loading && imageVerified && imageVerified.success === false) {
        setShowImageRecaptcha(true);
      }

    }, [imageVerified, loading,onValidToken,recaptchaV2Token]);
    

    return (
      <>
        {showImageRecaptcha && recaptchaReady && !imageVerified.success && (
          <div className="mt-4">
            <ReCAPTCHA
              sitekey={process.env.REACT_APP_RECAPTCHA_KEY_V2 || ''}
              onChange={handleImageRecaptcha}
              hl={locale.short}
            />
          </div>
        )}
    </>
    );
  };

  export default injectIntl(Recaptcha); 
